import GoalsApi from '__mocks__/mockApi/goals-api';
import IconsApi from '__mocks__/mockApi/icons-api';
import ExerciseLogsApi from '__mocks__/mockApi/exercise-log-api';
import PatientAnswersApi from '__mocks__/mockApi/patient-answers-api';
import PatientMetaDataApi from '__mocks__/mockApi/patient-meta-data-api';
import SocketApi from '__mocks__/mockApi/socket-api';
import SystemMessageApi from '__mocks__/mockApi/system-messages-api';
import UserCoursesApi from '__mocks__/mockApi/user-courses-api';
import FoodLogApi from '__mocks__/mockApi/food-logs-api';
import FilesApi from '__mocks__/mockApi/files-api';
import RecommendationApi from '__mocks__/mockApi/recommendation-api';
import UserRolesApi from '__mocks__/mockApi/user-roles-api';
import AdminRecipesApi from '__mocks__/mockApi/admin-recipes-api';
import PatientsDataApi from '__mocks__/mockApi/patients-api';
import OrganizationUsers from '__mocks__/mockApi/organization-users';
import UsersApi from '__mocks__/mockApi/users-api';
import AuthenticationApi from '__mocks__/mockApi/authentication-api';
import DomoEmbedSections from '__mocks__/mockApi/domo-embed-sections';
import DomoEmbeds from '__mocks__/mockApi/domo-embeds';
import ProviderApi from '__mocks__/mockApi/providers-api';
import CountriesApi from '__mocks__/mockApi/countries-api';
import ZipCodesApi from '__mocks__/mockApi/zip-codes-api';
import StatesApi from '__mocks__/mockApi/states-api';
import { ZendeskApi, ZendeskReportApi } from '__mocks__/mockApi/zendesk-api';
import ConversationsApi from '__mocks__/mockApi/conversations-api';
import PatientsListApi from '__mocks__/mockApi/patients-list-api';
import ProgressNotesApi from '__mocks__/mockApi/progress-notes-api';
import ActivityLogsApi from '__mocks__/mockApi/activity-logs-api';
import NutritionGoalsApi from '__mocks__/mockApi/nutrition-goals-api';
import PatientNutritionGoalsApi from '__mocks__/mockApi/patient-nutrition-goals-api';
import LanguageApi from '__mocks__/mockApi/language-api';
import OrganizationsApi from '__mocks__/mockApi/organizations-api';
import VariablesApi from '__mocks__/mockApi/variables-api';
import DiagnosisSymptomsApi from '__mocks__/mockApi/diagnosis-symptoms-api';
import ProviderInterestsApi from '__mocks__/mockApi/provider-interests-api';
import ProviderDegreesApi from '__mocks__/mockApi/provider-degrees-api';
import PatientAvailabilitiesApi from '__mocks__/mockApi/patient-availabilities-api';
import OrganizationTypesApi from '__mocks__/mockApi/organization-types-api';
import OrganizationInterestsApi from '__mocks__/mockApi/organization-interests-api';
import InsurancePlansApi from '__mocks__/mockApi/insurance-plans-api';
import InsuranceAffiliationApi from '__mocks__/mockApi/insurance-affiliation-api';
import ClinicalSpecialtyApi from '__mocks__/mockApi/clinical-specialty-api';
import UserSettingsApi from '__mocks__/mockApi/user-settings-api';
import EhrApi from '__mocks__/mockApi/ehr-api';
import ProgramsApi from '__mocks__/mockApi/programs-api';
import DeduApi from '__mocks__/mockApi/dedu-api';
import OrganizationTagsApi from '__mocks__/mockApi/organization-tags-api';
import CronJobApi from '__mocks__/mockApi/cron-job-api';
import DevicesApi from '__mocks__/mockApi/devices-api';
import RpmLogsApi from '__mocks__/mockApi/rpm-logs-api';
import ProvidersPatients from '__mocks__/mockApi/providers-patients-api';
import RpmStatusApi from '__mocks__/mockApi/rpm-status';
import RpmSummaryApi from '__mocks__/mockApi/rpm-summary-api';
import RpmEventsApi from '__mocks__/mockApi/rpm-events-api';
import BloodPressureApi from '__mocks__/mockApi/blood-pressure-api';
import PulseRateApi from '__mocks__/mockApi/pulse-rate-api';
import PatientRecipesApi from '__mocks__/mockApi/patient-recipes-api';
import RecipesApi from '__mocks__/mockApi/recipes-api';
import RecommendationToUserHistoryApi from './mockApi/recommendation-to-user-history-api';
import UserDevicesApi from './mockApi/user-devices-api';
import SelfRegistrationApi from './mockApi/self-registration-api';
import AppointmentsApi from './mockApi/appointments-api';
import AthenaPatientSyncApi from './mockApi/athena-patient-sync';
import CurrentMedications from './mockApi/current-medications-api';
import Medications from './mockApi/medications-api';
import ProvidersBusinessHours from './mockApi/providers-business-hours-api';
import ProviderRolesApi from './mockApi/provider-roles-api';
import ActionItemsApi from './mockApi/action-items-api';
import VideoConference from './mockApi/video-conference-api';
import UserCalendarPreferences from './mockApi/user-calendar-preference-api';
import PatientExtract from './mockApi/patient-extract-api';
import PatientVitals from './mockApi/patient-vitals-api';
import QuestionnaireApi from './mockApi/questionnaire-api';

export const handlers = [
  ...GoalsApi,
  ...IconsApi,
  ...ExerciseLogsApi,
  ...PatientAnswersApi,
  ...PatientMetaDataApi,
  ...SocketApi,
  ...SystemMessageApi,
  ...UserCoursesApi,
  ...FoodLogApi,
  ...FilesApi,
  ...RecommendationApi,
  ...RecommendationToUserHistoryApi,
  ...UserRolesApi,
  ...AdminRecipesApi,
  ...OrganizationUsers,
  ...UsersApi,
  ...AuthenticationApi,
  ...DomoEmbedSections,
  ...DomoEmbeds,
  ...ProviderApi,
  ...CountriesApi,
  ...ZipCodesApi,
  ...StatesApi,
  ...PatientsDataApi,
  ...ZendeskApi,
  ...ConversationsApi,
  ...PatientsListApi,
  ...ProgressNotesApi,
  ...ActivityLogsApi,
  ...NutritionGoalsApi,
  ...PatientNutritionGoalsApi,
  ...LanguageApi,
  ...OrganizationsApi,
  ...VariablesApi,
  ...DiagnosisSymptomsApi,
  ...ProviderInterestsApi,
  ...ProviderDegreesApi,
  ...PatientAvailabilitiesApi,
  ...OrganizationTypesApi,
  ...OrganizationInterestsApi,
  ...InsurancePlansApi,
  ...InsuranceAffiliationApi,
  ...ClinicalSpecialtyApi,
  ...UserSettingsApi,
  ...EhrApi,
  ...ProgramsApi,
  ...DeduApi,
  ...OrganizationTagsApi,
  ...CronJobApi,
  ...DevicesApi,
  ...RpmLogsApi,
  ...ProvidersPatients,
  ...RpmStatusApi,
  ...RpmSummaryApi,
  ...RpmEventsApi,
  ...BloodPressureApi,
  ...PulseRateApi,
  ...PatientRecipesApi,
  ...UserDevicesApi,
  ...RecipesApi,
  ...SelfRegistrationApi,
  ...AppointmentsApi,
  ...UserDevicesApi,
  ...AthenaPatientSyncApi,
  ...CurrentMedications,
  ...Medications,
  ...ProvidersBusinessHours,
  ...ProviderRolesApi,
  ...ActionItemsApi,
  ...VideoConference,
  ...ZendeskReportApi,
  ...UserCalendarPreferences,
  ...PatientExtract,
  ...PatientVitals,
  ...QuestionnaireApi,
];
